import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useApp } from '@/context/AppContext';
import { PageHeader, Card } from '@/components/common';
import { formatCurrency } from '@/lib/format';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';

const tabs = ['clients', 'products', 'services', 'projects', 'departments'];

const Profitability = () => {
  const { t, tx, lang, data } = useApp();
  const [tab, setTab] = useState('clients');
  const rows = [...data.profitability[tab]].sort((a, b) => b.margin - a.margin);

  return (
    <div>
      <PageHeader title={t('prof.title')} subtitle={t('prof.subtitle')} />
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-5 flex flex-wrap h-auto bg-white/[0.96] backdrop-blur-xl border border-white/80 p-1 rounded-xl">
          {tabs.map((tb) => (
            <TabsTrigger key={tb} value={tb} data-testid={`prof-tab-${tb}`} className="data-[state=active]:bg-cyan-500 data-[state=active]:text-white rounded-lg px-4">
              {t(`prof.${tb}`)}
            </TabsTrigger>
          ))}
        </TabsList>

        {tabs.map((tb) => (
          <TabsContent key={tb} value={tb}>
            <Card className="overflow-hidden" data-testid={`prof-table-${tb}`}>
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-left text-[11px] uppercase tracking-wider text-zinc-400 border-b border-zinc-100">
                    <th className="py-3 px-5 font-semibold">{t('prof.name')}</th>
                    <th className="py-3 px-5 font-semibold text-right">{t('finance.revenue')}</th>
                    <th className="py-3 px-5 font-semibold text-right">{t('prof.marginPct')}</th>
                    <th className="py-3 px-5 font-semibold w-1/3 hidden sm:table-cell">{t('prof.contribution')}</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r, i) => {
                    const neg = r.margin < 0;
                    return (
                      <motion.tr key={i} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: i * 0.04 }} className="border-b border-zinc-50 hover:bg-zinc-50/60 transition-colors">
                        <td className="py-3.5 px-5 font-medium text-zinc-800">{tx(r.name)}</td>
                        <td className="py-3.5 px-5 text-right font-mono-num text-zinc-700">{formatCurrency(r.revenue, lang)}</td>
                        <td className={`py-3.5 px-5 text-right font-mono-num font-semibold ${neg ? 'text-rose-500' : 'text-emerald-600'}`}>{r.margin > 0 ? '+' : ''}{r.margin}%</td>
                        <td className="py-3.5 px-5 hidden sm:table-cell">
                          <div className="h-2 w-full rounded-full bg-zinc-100 overflow-hidden">
                            <div className={`h-full rounded-full ${neg ? 'bg-rose-400' : 'bg-cyan-500'}`} style={{ width: `${Math.min(Math.abs(r.margin) * 2.5, 100)}%` }} />
                          </div>
                        </td>
                      </motion.tr>
                    );
                  })}
                </tbody>
              </table>
            </Card>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
};

export default Profitability;
